var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/avatar/male",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9984868,11 C10.9984868,8.790861 12.7900253,7 15,7 C17.2099747,7 19.0015132,8.790861 19.0015132,11 C19.0015132,13.209139 17.2099747,15 15,15 C13.9387327,15 12.9209322,14.5785726 12.1705029,13.8284271 C11.4200736,13.0782816 10.9984868,12.060866 10.9984868,11 Z M15.0036706,10.0556196 C14.4110817,10.0556196 13.8175909,10.0538179 13.2231981,10.0565204 C12.7442564,10.059223 12.3708442,10.3592028 12.3176285,10.8339456 C12.2833539,11.1465372 12.2887657,11.4726414 12.3311579,11.7843321 C12.5070404,13.0734346 13.5623357,14.0238211 14.8638665,14.0931858 C16.0156717,14.1535421 17.070065,13.4824161 17.5039086,12.4140195 C17.6852029,11.9699052 17.70685,11.5041708 17.7014382,11.0321305 C17.6942225,10.4321708 17.3235163,10.0556196 16.7246136,10.0556196 C16.150966,10.0556196 15.5773183,10.0556196 15.0036706,10.0556196 L15.0036706,10.0556196 Z M22.8929849,21.55 L21.4524401,18.66 C20.9434502,17.6408424 19.9009548,16.9977614 18.7614224,16.9999942 L11.2385776,16.9999942 C10.0990452,16.9977614 9.0565498,17.6408424 8.54755991,18.66 L7.10701515,21.55 C6.9509869,21.8595182 6.96641672,22.2277279 7.14779364,22.5231178 C7.32917056,22.8185078 7.65062751,22.9989511 7.99735184,22.9999942 L22.0026482,22.9999942 C22.3493725,22.9989511 22.6708294,22.8185078 22.8522064,22.5231178 C23.0335833,22.2277279 23.0490131,21.8595182 22.8929849,21.55 Z",
    id: "Icon-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.da3b4f04.svg";
export { ForwardRef as ReactComponent };